import React, { useContext, useEffect, useState } from "react";
import { toast } from 'react-toastify';

import {
    DashboardSpacer,
    PageTitle,
    PageSubtitle,
    PageText
} from "../styled";

import {
    MemoryCard,
    MemoryLabel,
    MemoryValue,
    MemoryChips,
    MemoryChip,
    MemorySummary,
    MemoryNote
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";

import { CoreContext } from "context/CoreContext";
import { Container, Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import Button from "components/Button";
import { LerMinhaMemoria, ApagarMinhaMemoria } from "services/memoria";
import { deleteAllHistory } from "services/conversationHistory";

// Mesmos nomes do servidor (PERSONAGENS e MODOS em controllers/chat.js)
const PERSONAGENS = { salomao: 'Salomão', davi: 'Davi', ester: 'Ester', daniel: 'Daniel' };
const MODOS = { chat: 'Bate-papo', learn: 'Praticar idiomas' };

// O 4º teto da memória: a pessoa vê e apaga o que os personagens guardaram.
export default function DashboardAccountMemory(){
    const history = useHistory();

    const { user } = useContext(CoreContext)

    const [memoria, setMemoria] = useState(null)
    const [loading, setLoading] = useState(false)
    const [confirmando, setConfirmando] = useState(false)
    const [apagando, setApagando] = useState(false)

    const init = async () => {
        setLoading(true)
        const result = await LerMinhaMemoria()
        setLoading(false)
        if(result && !result.error && typeof result.guardado === 'boolean'){
            setMemoria(result)
        }else{
            toast.error('Não consegui consultar agora. Tente de novo mais tarde.')
        }
    }

    const apagar = async () => {
        setApagando(true)
        const result = await ApagarMinhaMemoria()
        setApagando(false)
        if(result && result.apagado){
            // As mensagens que este navegador mostra na tela de conversa também saem,
            // senão a pessoa veria uma conversa que o personagem já esqueceu.
            if(user?.id){ deleteAllHistory(user.id) }
            setConfirmando(false)
            toast.success('Pronto. Os personagens esqueceram tudo.')
            init()
        }else{
            toast.error('Não consegui apagar agora. Tente de novo.')
        }
    }

    useEffect(() => {
        init()
    }, [])

    const conversas = memoria?.conversas || []
    const interesses = memoria?.interesses || []

    return (
        <>
            <ContainerAuthenticated>
                <Container>
                    <Row>
                        <Col md={{ size: 6, offset: 3 }}>
                            <DashboardSpacer />
                            <PageTitle>Memória dos personagens</PageTitle>
                            <PageText>
                                Para continuar a conversa de onde parou, os personagens guardam um pouco do que vocês conversaram.
                                Aqui você vê tudo o que foi guardado e pode apagar quando quiser.
                            </PageText>

                            { loading && !memoria ? <PageText>Carregando...</PageText> : null }

                            {
                                memoria && !memoria.guardado ? (
                                    <MemoryCard>
                                        <MemoryValue>Os personagens não têm nada guardado sobre você.</MemoryValue>
                                        <MemoryNote>Quando você conversar, eles vão lembrar do seu nome, do idioma e de até { memoria.teto_de_interesses } assuntos de que você gosta.</MemoryNote>
                                    </MemoryCard>
                                ) : null
                            }

                            {
                                memoria?.guardado ? <>
                                    <PageSubtitle>O que eles lembram entre uma conversa e outra</PageSubtitle>
                                    <MemoryCard>
                                        <MemoryLabel>Seu nome</MemoryLabel>
                                        <MemoryValue>{ memoria.nome || 'Não guardado' }</MemoryValue>

                                        <MemoryLabel>Idioma que você pediu</MemoryLabel>
                                        <MemoryValue>{ memoria.idioma || 'Não guardado' }</MemoryValue>

                                        <MemoryLabel>Assuntos de que você gosta (até { memoria.teto_de_interesses })</MemoryLabel>
                                        {
                                            interesses.length ? (
                                                <MemoryChips>
                                                    { interesses.map(item => <MemoryChip key={item}>{ item }</MemoryChip>) }
                                                </MemoryChips>
                                            ) : <MemoryValue>Nenhum</MemoryValue>
                                        }

                                        <MemoryNote>Isto se apaga sozinho depois de { memoria.apaga_sozinho_em_dias } dias sem conversar.</MemoryNote>
                                    </MemoryCard>

                                    <PageSubtitle>Conversas guardadas</PageSubtitle>
                                    {
                                        conversas.length ? conversas.map(conversa => (
                                            <MemoryCard key={ `${ conversa.personagem }-${ conversa.modo }` }>
                                                <MemoryLabel>{ PERSONAGENS[conversa.personagem] || conversa.personagem } · { MODOS[conversa.modo] || conversa.modo }</MemoryLabel>
                                                <MemoryValue>{ conversa.mensagens_guardadas } { conversa.mensagens_guardadas === 1 ? 'mensagem guardada' : 'mensagens guardadas' }</MemoryValue>
                                                { conversa.resumo ? <MemorySummary><b>Resumo do que veio antes:</b> { conversa.resumo }</MemorySummary> : null }
                                            </MemoryCard>
                                        )) : <PageText>Nenhuma conversa guardada.</PageText>
                                    }

                                    {
                                        confirmando ? (
                                            <MemoryCard warning>
                                                <MemoryValue><b>Tem certeza?</b></MemoryValue>
                                                <MemoryNote>
                                                    Os personagens vão esquecer seu nome, seus assuntos e as conversas guardadas,
                                                    e as mensagens antigas somem da tela de conversa. Isso não pode ser desfeito.
                                                </MemoryNote>
                                                <Button primary loading={apagando} onClick={apagar}>Sim, apagar tudo</Button>
                                                <Button outline onClick={() => setConfirmando(false)}>Não apagar</Button>
                                            </MemoryCard>
                                        ) : (
                                            <Button primary onClick={() => setConfirmando(true)}>Apagar tudo</Button>
                                        )
                                    }
                                </> : null
                            }

                            <Button outline onClick={() => history.goBack()}>Voltar</Button>
                            <DashboardSpacer />
                        </Col>
                    </Row>
                </Container>
            </ContainerAuthenticated>
        </>
    );

}
